import "oc-commons/extensions/StringExtensions";
import { AbstractApp } from "oc-app/AbstractApp";
import * as Commons from "oc-commons/Commons";
import { Stage } from "oc-threejs/Stage";
import { UniversalLoader } from "oc-threejs/loader/UniversalLoader";
// import { Wkfg2BackendApi } from "oc-app/Wkfg2BackendApi";
// import { Wkfg2TypeConverter } from "oc-app/Wkfg2TypeConverter";
import { SceneWkfg2Importer } from "oc-app/scene/SceneWkfg2Importer";
import * as Scenes from "oc-threejs/Scenes";
import { v3 } from "oc-threejs/short3";
import { Jaco } from "./arrangement/Jaco";
import { Jaco3d } from "./arrangement3d/Jaco3d";
import { AbstractRichMetadata } from "oc-app/AbstractRichMetadata";
import { Urls } from "oc-commons/Urls";
import { JacoAppMinimumMixin } from "./JacoAppMinimumMixin";
import { BaseInteractionHandler3D } from "oc-interaction/BaseInteractionHandler3D";
import * as _ from "lodash";

// Global declaration
interface IAppGlobal {
  dirty: () => void;
  metadata: any;
}
declare const APP: IAppGlobal;

interface IStageGlobal {
  settings: { showDebugObjects: boolean; showGround: boolean };
  addAxisHelper: () => void;
  addGroundScalePaper: () => void;
  on: (event: string, cb: () => void) => void;
  startRenderLoop: () => void;
}
declare const STAGE: IStageGlobal;

const MixedJacoApp = JacoAppMinimumMixin(AbstractApp as any);

export class JacoApp extends MixedJacoApp {
  /** @type {string} */
  version: string | undefined;
  /** @type {SceneWkfg2Importer} */
  sceneImporter: SceneWkfg2Importer | undefined;

  /** @type {AbstractRichMetadata} */
  richMetadata: AbstractRichMetadata | undefined;

  /** @type {BaseInteractionHandler3D} */
  interactionHandler: BaseInteractionHandler3D | undefined;

  configuration: any;
  settings: any; // Inherited from AbstractApp via mixin, but strictly typing it here

  constructor(name: string, container: any, configuratorSettings: any) {
    super(name, container, configuratorSettings);
  }

  _appInitialize(settings: any) {
    super._appInitialize(settings);
    this.loadAppData();
  }

  loadInitialConfigData() {
    const isAdmin = this.settings.userRole == "admin";
    const tenant = Urls.urlParam("tenant");
    const tenantOptions = isAdmin && !Commons.isEmpty(tenant) ? { tenant } : {};
    return this.loadConfigData({
      ...tenantOptions,
      code: Urls.urlParam("Code"),
      lang: Urls.urlParam("lang"),
      metamodell: true,
      i18n: true,
    });
  }

  loadAppData() {
    this.addOnUnloadWarning();
    this.loadInitialConfigData().then(() => {
      this.initApp();
      this.maybeInitAdminApp();
    });
  }

  getStageAsConfiguration() {
    if (this.configuration != null && this.arrangement != null) {
      this.configuration.Json = Commons.cloneDeep(this.arrangement.toJSON());
    }
    return this.configuration;
  }

  setStageFromConfiguration(configuration: any = null) {
    if (configuration == null) {
      configuration = this.createDefaultConfiguration();
    }
    console.log("setStageFromConfiguration", _.cloneDeep(configuration));
    this.configuration = configuration;
    if (this.arrangement) {
      this.arrangement.fromJSON(this.configuration.Json);
      this.arrangement.update3d();
    }
    APP.dirty();
  }

  createDefaultConfiguration() {
    return {
      Json: {},
    };
  }

  initApp() {
    this.richMetadata = this.createRichMetadata();
    this.initReadyEventTrigger();
    this.initStage();
    this.initArrangement();
    this.initUI();
    this.loadInitialConfigurationFromApp();
  }

  initReadyEventTrigger() {
    this.onOnce("loadedInitialConfiguration", () => {
      UniversalLoader.delayUntilEverythingLoaded(() => {
        this.trigger("ready");
      }, "hideInitialLoadingDialog");
    });
  }

  maybeInitAdminApp() {
    // new AdminApp();
  }

  // createWkfgBackendApi() {
  //     return new Wkfg2BackendApi(this.settings.wkfgBackendUrl, this.createWkfgTypeConverter());
  // }

  // createWkfgTypeConverter() {
  //     return new Wkfg2TypeConverter();
  // }

  initStage(envName: string | null = null) {
    this.initSceneImporter();

    this.createStage();

    if (STAGE.settings.showDebugObjects) {
      STAGE.addAxisHelper();
    }

    if (STAGE.settings.showGround) {
      STAGE.addGroundScalePaper();
    }

    UniversalLoader.setMaterialFactory(this.sceneImporter);

    if (this.interactionHandler) {
      (this.interactionHandler as any).setSceneDroppable(); // Assume method exists or cast
    }

    STAGE.on("beforeRenderScene", () => this.onBeforeRenderStage());

    STAGE.startRenderLoop();
  }

  initSceneImporter() {
    this.sceneImporter = new SceneWkfg2Importer(this.settings.wkfgContentBaseUrl);
  }

  createStage() {
    return new Stage(this.settings.stage);
  }

  initUI() {
    this.ui = this.createUI();
  }

  createUI() {}

  createInteractionHandler() {}

  initArrangement() {
    this.arrangement = this.createArrangement();
    this.dirty();
  }

  createArrangement(): Jaco {
    return new Jaco(null);
  }

  createRichMetadata() {
    return new AbstractRichMetadata();
  }
}

(self as any).Commons = Commons;
